export default {
    ENV: "local",
    BASE_URL: "https://vetdev.wiley.com/",
    CHECKOUT_URL: "https://dev.checkout.wiley.com/en-us/",
    ADD_TO_CART_URL: "https://vetdev.wiley.com/cart-cta.js",
    ADOBE_ANALYTICS_MODE: "dev",
    ADOBE_ANALYTICS_SCRIPT_URL: "https://assets.adobedtm.com/59640f9fa510/30a2f2139949/launch-c1b9d683b9d2-development.min.js",
    LOCALE: "en-us",
    OSANO_SCRIPT_URL:
        "https://cmp.osano.com/AzZdRbSORDOOzF9W/23959def-701d-4c80-ab4b-a48678aa3da4/osano.js",
};